type Props = {
  className?: string;
};
const USFlag = ({ className }: Props) => {
  return (
    <svg
      className={className}
      viewBox="0 0 32 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_137_83018)">
        <rect width="32" height="24" rx="3" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H32V24H0V0Z"
          fill="#F7FCFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 14.6667V16.6667H32V14.6667H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 18.3333V20.3333H32V18.3333H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 7.33333V9.33333H32V7.33333H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 22V24H32V22H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 11V13H32V11H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V2H32V0H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 3.66667V5.66667H32V3.66667H0Z"
          fill="#E31D1C"
        />
        <rect width="20" height="13" fill="#2E42A5" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.72221 2.93868L0.996331 3.44756L1.2414 2.54195L0.59668 1.96804H1.43877L1.7212 1.22897L2.05237 1.96804H2.77022L2.20619 2.54195L2.42455 3.44756L1.72221 2.93868ZM5.72221 2.93868L4.99633 3.44756L5.2414 2.54195L4.59668 1.96804H5.43877L5.7212 1.22897L6.05237 1.96804H6.77022L6.20619 2.54195L6.42455 3.44756L5.72221 2.93868ZM8.99633 3.44756L9.72221 2.93868L10.4245 3.44756L10.2062 2.54195L10.7702 1.96804H10.0524L9.7212 1.22897L9.43877 1.96804H8.59668L9.2414 2.54195L8.99633 3.44756ZM13.7222 2.93868L12.9963 3.44756L13.2414 2.54195L12.5967 1.96804H13.4388L13.7212 1.22897L14.0524 1.96804H14.7702L14.2062 2.54195L14.4245 3.44756L13.7222 2.93868ZM0.996331 7.44756L1.72221 6.93867L2.42455 7.44756L2.20619 6.54195L2.77022 5.96804H2.05237L1.7212 5.22897L1.43877 5.96804H0.59668L1.2414 6.54195L0.996331 7.44756ZM5.72221 6.93867L4.99633 7.44756L5.2414 6.54195L4.59668 5.96804H5.43877L5.7212 5.22897L6.05237 5.96804H6.77022L6.20619 6.54195L6.42455 7.44756L5.72221 6.93867ZM8.99633 7.44756L9.72221 6.93867L10.4245 7.44756L10.2062 6.54195L10.7702 5.96804H10.0524L9.7212 5.22897L9.43877 5.96804H8.59668L9.2414 6.54195L8.99633 7.44756ZM13.7222 6.93867L12.9963 7.44756L13.2414 6.54195L12.5967 5.96804H13.4388L13.7212 5.22897L14.0524 5.96804H14.7702L14.2062 6.54195L14.4245 7.44756L13.7222 6.93867ZM0.996331 11.4476L1.72221 10.9387L2.42455 11.4476L2.20619 10.542L2.77022 9.96804H2.05237L1.7212 9.22897L1.43877 9.96804H0.59668L1.2414 10.542L0.996331 11.4476ZM5.72221 10.9387L4.99633 11.4476L5.2414 10.542L4.59668 9.96804H5.43877L5.7212 9.22897L6.05237 9.96804H6.77022L6.20619 10.542L6.42455 11.4476L5.72221 10.9387ZM8.99633 11.4476L9.72221 10.9387L10.4245 11.4476L10.2062 10.542L10.7702 9.96804H10.0524L9.7212 9.22897L9.43877 9.96804H8.59668L9.2414 10.542L8.99633 11.4476ZM13.7222 10.9387L12.9963 11.4476L13.2414 10.542L12.5967 9.96804H13.4388L13.7212 9.22897L14.0524 9.96804H14.7702L14.2062 10.542L14.4245 11.4476L13.7222 10.9387ZM16.9963 3.44756L17.7222 2.93868L18.4245 3.44756L18.2062 2.54195L18.7702 1.96804H18.0524L17.7212 1.22897L17.4388 1.96804H16.5967L17.2414 2.54195L16.9963 3.44756ZM17.7222 6.93867L16.9963 7.44756L17.2414 6.54195L16.5967 5.96804H17.4388L17.7212 5.22897L18.0524 5.96804H18.7702L18.2062 6.54195L18.4245 7.44756L17.7222 6.93867ZM16.9963 11.4476L17.7222 10.9387L18.4245 11.4476L18.2062 10.542L18.7702 9.96804H18.0524L17.7212 9.22897L17.4388 9.96804H16.5967L17.2414 10.542L16.9963 11.4476ZM3.72221 4.93867L2.99633 5.44756L3.2414 4.54195L2.59668 3.96804H3.43877L3.7212 3.22897L4.05237 3.96804H4.77022L4.20619 4.54195L4.42455 5.44756L3.72221 4.93867ZM6.99633 5.44756L7.72221 4.93867L8.42455 5.44756L8.20619 4.54195L8.77022 3.96804H8.05237L7.7212 3.22897L7.43877 3.96804H6.59668L7.2414 4.54195L6.99633 5.44756ZM11.7222 4.93867L10.9963 5.44756L11.2414 4.54195L10.5967 3.96804H11.4388L11.7212 3.22897L12.0524 3.96804H12.7702L12.2062 4.54195L12.4245 5.44756L11.7222 4.93867ZM2.99633 9.44756L3.72221 8.93867L4.42455 9.44756L4.20619 8.54195L4.77022 7.96804H4.05237L3.7212 7.22897L3.43877 7.96804H2.59668L3.2414 8.54195L2.99633 9.44756ZM7.72221 8.93867L6.99633 9.44756L7.2414 8.54195L6.59668 7.96804H7.43877L7.7212 7.22897L8.05237 7.96804H8.77022L8.20619 8.54195L8.42455 9.44756L7.72221 8.93867ZM10.9963 9.44756L11.7222 8.93867L12.4245 9.44756L12.2062 8.54195L12.7702 7.96804H12.0524L11.7212 7.22897L11.4388 7.96804H10.5967L11.2414 8.54195L10.9963 9.44756ZM15.7222 4.93867L14.9963 5.44756L15.2414 4.54195L14.5967 3.96804H15.4388L15.7212 3.22897L16.0524 3.96804H16.7702L16.2062 4.54195L16.4245 5.44756L15.7222 4.93867ZM14.9963 9.44756L15.7222 8.93867L16.4245 9.44756L16.2062 8.54195L16.7702 7.96804H16.0524L15.7212 7.22897L15.4388 7.96804H14.5967L15.2414 8.54195L14.9963 9.44756Z"
          fill="#F7FCFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_137_83018">
          <rect width="32" height="24" rx="3" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default USFlag;
